import { Button, Paper, ScrollArea, Stack, Text } from '@mantine/core';
import { useQuery } from '@tanstack/react-query';
import { Phone } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { supportQueries } from '../../data-access/queries/support';

import classes from './page.module.css';

import { FullMainHeight } from '@ui';

export function EquipePrecifieldPage() {
  const { t } = useTranslation();
  const usersQuery = useQuery(supportQueries.precifieldUsers);

  return (
    <FullMainHeight.Root>
      <FullMainHeight.Content className={classes.content}>
        <Stack gap={0} h="100%">
          <header className={classes.header}>
            <Text className={classes.headerTitle}>{t('supportPage.team.title')}</Text>
          </header>

          <ScrollArea h="100%">
            <Stack className={classes.listStack} gap="md">
              {usersQuery.data?.results.length === 0 ? (
                <Paper className={classes.card} p="md" radius="lg" withBorder>
                  <Text c="dimmed" size="sm">
                    {t('supportPage.team.empty')}
                  </Text>
                </Paper>
              ) : null}

              {usersQuery.data?.results.map((user) => (
                <Paper className={classes.card} key={user.id} p="md" radius="lg" withBorder>
                  <Stack gap={10}>
                    <Text className={classes.name}>
                      {user.first_name} {user.last_name}
                    </Text>
                    <span className={classes.greenBar} />
                    <Text className={classes.contactLine}>
                      {t('supportPage.team.email')}: {user.email?.trim() ? user.email : '-'}
                    </Text>
                    <Button
                      className={classes.callButton}
                      component={user.phone_number?.trim() ? 'a' : 'button'}
                      href={user.phone_number?.trim() ? `tel:${user.phone_number}` : undefined}
                      leftSection={<Phone size={16} />}
                      radius="xl"
                      variant="light"
                    >
                      {user.phone_number?.trim() ? user.phone_number : t('supportPage.team.phoneUnavailable')}
                    </Button>
                  </Stack>
                </Paper>
              ))}
            </Stack>
          </ScrollArea>
        </Stack>
      </FullMainHeight.Content>
    </FullMainHeight.Root>
  );
}

export default EquipePrecifieldPage;
